<template>
  <div id="appointments-container" class="clearAfterFloats">
    <p v-if="windowWidth > 768" class="dayAndDate">
      <span class="dayOfTheWeek">{{ dayOfTheWeek + ", " }}</span>
      <span class="day-date">{{ appointmentsDate }}</span>
    </p>
    <div id="studioNameContainer">
      <ul id="studioNav" class="clearAfterFloats">
        <li
          v-for="(s,i) in studioList"
          :class="{studioSelected: i == 0}"
          :key="s.StudioId"
          :ref="s.StudioId"
          :id="'studio' + s.StudioId"
          @click="changeSelectedStudio(s.StudioId)"
        >{{s.Name}}</li>
      </ul>
    </div>
    <div id="timeline-container">
      <app-timeline v-for="time in regularAppointmentTime" :key="time" :time="time"></app-timeline>
    </div>
    <div id="appointments-per-day">
      <div v-if="windowWidth > 768" class="clearAfterFloats">
        <per-studio
          v-for="(appointments,i) in day.Studio"
          :key="i"
          :appointmentPerStudio="appointments.Appointments"
          class="largeScreen perStudio"
          :class="{'disabled-studio': appointments.StudioName === 'Empty studio'}"
        ></per-studio>
      </div>
      <per-studio
        v-if="windowWidth <= 768"
        class="perStudio"
        :appointmentPerStudio="selectedStudio.Appointments"
        :class="{'disabled-studio': selectedStudio.StudioName === 'Empty studio'}"
        @swipeSelectedStudio="swipeSelectedStudio"
      ></per-studio>
    </div>
  </div>
</template>

<script>
import Timeline from "./Timeline";
import PerStudio from "./PerStudio";

// Event bus
import { bus } from "../../main";

export default {
  props: [
    "appointmentsDate",
    "windowWidth",
    "dayOfTheWeek",
    "isLayoutOneDay",
    "day",
    "studioList",
    "numberOfStudioListPages",
    "selectedStudioPage"
  ],
  components: {
    appTimeline: Timeline,
    perStudio: PerStudio
  },
  data() {
    return {
      regularAppointmentTime: [],
      studio: [],
      //ONLY FOR SMALL SCREEN
      selectedStudio: {},
      selectedStudioIndex: 1
    };
  },
  methods: {
    fillAppointmentTime() {
      var i = 7;
      var timeInString = "";
      for (i; i <= 23; i++) {
        if (i < 10) {
          timeInString = "0" + i + ":00";
        } else {
          timeInString = i + ":00";
        }
        this.regularAppointmentTime.push(timeInString);
      }
    },
    getStudioByIndex() {
      this.$store.state.services.studioService
        .getByListIndex(this.studioListIndex)
        .then(res => {
          this.studio = res.data;
        });
    },
    changeSelectedStudio(studioId) {
      this.selectedStudioIndex = studioId;
      this.selectedStudio = this.day.Studio.find(x => x.StudioId === studioId);
      this.changeSelectedStudioBorder(studioId);
    },
    swipeSelectedStudio(direction) {
      let minIndex = 0;
      let maxIndex = this.numberOfStudioListPages;

      if (direction == "left" || direction == "right") {
        if (direction == "right") {
          if (
            this.day.Studio.indexOf(this.selectedStudio) === 0 &&
            this.selectedStudioPage === minIndex
          ) {
            //TODO: Implementirati logiku prebacivanja datuma
            return;
          }
          if (
            this.day.Studio.indexOf(this.selectedStudio) === 0 &&
            this.selectedStudioPage > minIndex
          ) {
            this.$emit("changeStudioListIndex", "subtract");
          } else {
            this.changeSelectedStudio(this.selectedStudioIndex - 1);
          }
        } else if (direction == "right") {
          this.changeSelectedStudio(this.selectedStudioIndex - 1);
        } else if (direction == "left") {
          if (
            this.day.Studio[this.day.Studio.indexOf(this.selectedStudio) + 1] &&
            this.day.Studio[this.day.Studio.indexOf(this.selectedStudio) + 1]
              .StudioId === -1
          ) {
            //TODO: Implementirati logiku prebacivanja datuma
            return;
          }
          if (
            this.day.Studio.indexOf(this.selectedStudio) === 3 &&
            this.selectedStudioPage < maxIndex
          ) {
            this.$emit("changeStudioListIndex", "add");
          } else {
            this.changeSelectedStudio(this.selectedStudioIndex + 1);
          }
        }
      }
    },
    changeSelectedStudioBorder(studioId) {
      var clickedStudio = document.getElementById("studio" + studioId);
      var preClickedStudio = document
        .getElementsByClassName("studioSelected")[0]
        .classList.remove("studioSelected");
      clickedStudio.classList.add("studioSelected");
    }
  },
  created() {
    // Event bus listener
    bus.$on("ebStudioListIndexChanged", data => {
      if (data === "add") {
        this.changeSelectedStudio(this.day.Studio[0].StudioId);
      } else {
        this.changeSelectedStudio(this.day.Studio[3].StudioId);
      }
    });
    bus.$on("ebDateChanged", data => {
      this.changeSelectedStudio(this.selectedStudio.StudioId);
    });
    // INITIAL STUDIO SET
    this.selectedStudio = this.day.Studio[0];
    this.fillAppointmentTime();
  }
};
</script>

<style scoped>
#timeline-container {
  width: 10%;
  float: left;
}
.dayAndDate {
  margin-bottom: 25px;
}
#studioNameContainer ul {
  padding: 0;
  list-style-type: none;
  margin-bottom: 15px;
}

#studioNameContainer ul li {
  display: block;
  width: calc(25% - 2.5%);
  text-align: center;
  cursor: pointer;
  float: left;
  font-weight: 500;
  color: #657786;
}
#studioNameContainer ul li:nth-child(1) {
  margin-left: 10%;
}

#appointments-per-day {
  width: 90%;
  float: left;
}
.dayOfTheWeek {
  font-size: 18px;
  border-left: 2px solid #039be5;
  padding-left: 5px;
}
.day-date {
  font-size: 14px;
  font-weight: 300;
}

.largeScreen {
  width: calc(25% - 10px);
  float: left;
  margin: 0 5px;
}
.perStudio {
  background-color: white;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  height: 1700px;
}
.disabled-studio {
  background-color: #727272;
}
@media (max-width: 768px) {
  #timeline-container {
    width: 20%;
    margin-left: -16px;
  }
  #appointments-per-day {
    width: calc(80% + 16px);
  }

  #studioNameContainer ul li {
    width: 25%;
    margin-bottom: 15px;
    margin-top: -20px;
  }
  #studioNameContainer ul li:nth-child(1) {
    margin: 0;
    margin-top: -20px;
  }
  .studioSelected {
    border-bottom: 2px solid #039be5;
    transition: 0.2s all ease-out;
  }
}
</style>
